import React from 'react';
import type { FileData } from '../FilesPanel';
import { COMMON_PAGE_TEXT } from '../lang';
import { type BlockDataItem, BlockDataValueType } from './types';
import { DisplayFileData } from '../DisplayFileData';

export type InformationDisplayBlockProps = {
  blockData: BlockDataItem[];
  defaultValue?: string;
};

export const InformationDisplayBlock: React.FunctionComponent<
  InformationDisplayBlockProps
> = props => {
  const { blockData, defaultValue = COMMON_PAGE_TEXT.NA } = props;
  const getValue = (
    value: BlockDataItem['value'],
    valueType: BlockDataValueType,
    defaultValueOverwrite: string,
  ): React.ReactNode => {
    switch (valueType) {
      case BlockDataValueType.FILE:
        return <DisplayFileData fileData={[value as FileData]} />;
      case BlockDataValueType.FILE_ARRAY:
        return <DisplayFileData fileData={value as FileData[]} />;
      default: {
        return <>{value ?? defaultValueOverwrite}</>;
      }
    }
  };

  return (
    <div>
      {blockData.map((item, index) => {
        const {
          label,
          value,
          valueType = BlockDataValueType.STRING,
          defaultValue: defaultValueOverwrite = defaultValue,
        } = item;
        return (
          <div
            key={index}
            className="grid grid-cols-2 justify-items-start items-start mx-8"
          >
            <div className="font-semibold mt-2">{label}</div>
            <div className="mt-2">
              {getValue(value, valueType, defaultValueOverwrite)}
            </div>
          </div>
        );
      })}
    </div>
  );
};
